import React from "react";  
import { Container, Row, Col} from "react-bootstrap";
import Particle from "../Particle";
import SalesContact from "./SalesContact";
import Image from 'react-bootstrap/Image';
import logo_contpaqi_mini from "../../Assets/logo_contpaqi_chico.png";


import sale_now from "../../Assets/sale_now.jpg";
import { FaWhatsapp } from "react-icons/fa";
import SalesCards from "./SalesCards";
import technical_support from "../../Assets/customer-support.png";
import advice from "../../Assets/interview.png";
import education from "../../Assets/education.png";
import development from "../../Assets/product-development.png";

function Sales() {

    return (
        <Container fluid className="sales-section">
            <Particle />
            <Container>
                <h1 className="project-heading">
                    <strong className="purple"> Somos Expertos Certificados en CONTPAQi®</strong>
                </h1>
                <Row style={{ textAlign: "left", padding: "10px", backgroundColor:"#004AAD", fontSize: "20px" }}>
                <h4 style={{textAlign:"center"}}>¿Qué es &nbsp; <Image src={logo_contpaqi_mini} style={{width:"200px"}}/> ?</h4><br/>
               
                CONTPAQi® Es el Software líder en México, diseñado con la misión de optimizar y facilitar la administración financiera de tu empresa.<br/>
                Con CONTPAQi® puedes optimizar en tu empresa en las siguientes áreas:
                <ul>
                    <li> Contabilidad</li>
                    <li> Facturación</li>
                    <li> Nómina</li>
                    <li> Recursos humanos</li>
                </ul> 
                
                </Row>
            </Container>
            <Container>
            
            <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                <Col md={3} sm={6} xs={12} className="sales-card">
                    <SalesCards
                    imgPath={technical_support}
                    isBlog={false}
                    title="Soporte Técnico Certificado"
                    description=" Contamos con asesores altamente capacitados para garantizar la correcta implementación de Contpaq y adaptarla a tus necesidades."
                    />
                </Col>
                <Col md={3} sm={6} xs={12}  className="sales-card">
                    <SalesCards
                    imgPath={advice}
                    isBlog={false}
                    title=" Asesoría Especializada"
                    description=" Estamos comprometidos con darte una atención inmediata y personalizada para no entorpecer tus tareas diarias y resolver los imprevistos."
                    />
                </Col>
                <Col md={3} sm={6} xs={12} className="sales-card">
                    <SalesCards
                    imgPath={education}
                    isBlog={false}
                    title="Capacitación"
                    description="Capacitamos y certificamos a tus empleados en todos los procesos de Contpaq, para lograr minimizar riesgos y optimizar tus procesos, ¡maximizamos tu inversión!"
                    />
                </Col>
                <Col md={3} sm={6} xs={12} className="sales-card">
                    <SalesCards
                    imgPath={development}
                    isBlog={false}
                    title="Implementaciones Completas"
                    description="Te acompañamos en todo el proceso de implementación, para obtener los mejores resultados y lograr el mejor aprovechamiento del sistema."
                    />
                </Col>
           </Row>
            </Container>
            <Container>
                
                <Row style={{backgroundColor:"black"}}>
                    <Col xs={12} md={6} lg={6} >
                        <Image src={sale_now} fluid />
                    </Col>
                    <Col xs={12} md={6} lg={6} style={{display:"block", margin:"auto"}}>
                       <h3 className="purple">
                            Escribenos mencionando el Codigo <span style={{color:"white"}}><b>NAANSALE10</b></span> y te 
                            regalamos el diagnostico de implementación, además las primeras 2 horas de servicio te hacemos un 10% de descuento.
                       </h3>
                    </Col>
                </Row>
            </Container>
            <Particle />
           
            <Container>
                <Row>
                <Col xs={12} md={6} lg={6}>
                        <p style={{ color: "white" }}>
                            <br/>
                            ¿Hay algo más específico que te gustaría saber sobre nosotros?
                        </p>
                        <p style={{ fontSize:"2.2em"}}> Escribenos por Whatsapp.
                            <a
                                href="https://wa.me/523323709483/?text=Estoy%20interesado%20en%20algun%20producto%20de%20CONTPAQi.%20%C2%BFMe%20puedes%20ayudar%3F"
                                target="_blank"
                                rel="noreferrer"
                                className="icon-colour-whats  sale-social-icons"
                            >
                                <FaWhatsapp />
                            </a>
                        </p>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                        <SalesContact />
                
                    </Col>
                </Row>

            </Container>
        </Container>
        
    );
}

export default Sales;